import React, { useEffect, useState } from 'react';
import ModalFormFluid from '../../components/forms/config/modal.form.fluids'
import ListTables from '../../components/shared/tables';
import Base from '../base';
import { Alert } from '@themesberg/react-bootstrap';
import { get } from '../../services/back.service';

function ListFluids() {
  const [msgGet ,setMsgGet] = useState('');
  const [fluids,setFluids] = useState([]);
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    type: ''
  });
  useEffect(() => {
    getFluids()
  }, []);

  const createFluids = (variant, msg) => {
    setAlert({ show: true, message: msg, type: variant });
    getFluids()
  };

  const getFluids = async()=>{
    const responseFluids = await get('/config/fluid/',{})
    if(responseFluids.success){
      setFluids(responseFluids.data);
    }else{
      setMsgGet(responseFluids.message)
    }       
  }

  const editButton = (row) => {
    return (
      <ModalFormFluid
        title="Modificar Fluido"
        button_text="Editar"
        button_variant="outline-primary"
        fluidSelect={row.id}
        callback={createFluids}
      ></ModalFormFluid>
    );
  };

  return (
    <Base>
      {/* <TempAlert show={alert.show} variant="success" message={alert.message} hide={setAlert} ></TempAlert> */}
      {alert.show && <Alert variant={alert.type} onClose={() => setAlert({show: false})} dismissible>{alert.message}</Alert>}
      <ModalFormFluid
        title="Crear Fluido"
        button_text="Crear Fluido"
        button_variant="primary"
        callback={createFluids}
      ></ModalFormFluid>
      <ListTables
        data={fluids}
        editar={editButton}
        messageWd={msgGet}
      />
    </Base>
  );
}

export default ListFluids;
